import { getMailSuffixes, getDynamicH5Url } from '@/api/global'
import organConfig from '@/utils/organConfig'
const global = {
  longTime: true, // 是否存储浏览器
  namespaced: true,
  state: {
    h5Url: organConfig.VUE_APP_H5_URL, // 动态配置的H5网址
    smsAreaList: [], // 国际区号
    mailSuffixesList: [], // 邮箱后缀集合
    orderChecked: false // 是否不再提醒
  },
  mutations: {
    SET_SMSAREALIST: (state, data) => {
      state.smsAreaList = data
    },
    SET_MAILSUFFIXESLIST: (state, data) => {
      state.mailSuffixesList = data
    },
    SET_DYNAMICH5URL: (state, data) => {
      state.h5Url = data
    },
    SET_ORDERCHECKED: (state, data) => {
      state.orderChecked = data
    }
  },
  actions: {
    // 设置是否不再提醒下单
    set_orderChecked({ commit }, data) {
      commit('SET_ORDERCHECKED', data)
    },
    getSmsAreaCodes({ commit }) {
      fetch(
        `${organConfig.ossUrl
        }/message/areaDataJson.json?t=${new Date().getTime()}`
      )
        .then(response => {
          if (response.ok) {
            return response.json()
          }
        })
        .then(res => {
          if (res.code === 1 && res.data) {
            commit('SET_SMSAREALIST', res.data)
          }
        })
    },
    async getDynamicH5Url({ commit }, data) {
      console.log('data?.moduleCode', data?.moduleCode)
      const { code, data } = await getDynamicH5Url({ domainType: 'middle', moduleCode: data?.moduleCode || 'material_goods' })
      if (code === 1 && data) {
        commit('SET_DYNAMICH5URL', `https://${data}`)
      }
    },
    async getMailSuffixesList({ commit }) {
      const { code, data } = await getMailSuffixes({ suffixes: '' })
      if (code === 1 && data) {
        console.log(data)
        commit('SET_MAILSUFFIXESLIST', data)
      }
    }
  }
}
export default global
